<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card
    [title]="pageTitle"
    desc="Complete los datos del origen de negocio"
  >
    <!-- Loading -->
    @if (loading) {
      <div class="flex justify-center items-center py-12">
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
        ></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400"
          >Cargando datos...</span
        >
      </div>
    }

    <!-- Error -->
    @if (error) {
      <div
        class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
      >
        <div class="flex items-center gap-3">
          <svg
            class="w-5 h-5 text-error-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <p class="text-error-600 dark:text-error-400">{{ error }}</p>
        </div>
      </div>
    }

    <!-- Formulario -->
    @if (!loading) {
      <form
        (ngSubmit)="guardar()"
        #itemForm="ngForm"
        class="space-y-5"
      >
        <!-- Nombre -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Nombre <span class="text-error-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            [(ngModel)]="name"
            appPreventSpecialCharacters
            appPreventLongNames
            (invalidNameLength)="setError($event)"
            (invalidCharacter)="setError($event)"
            (input)="error = ''"
            required
            placeholder="Ej: Referido, Web, Llamada fría"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Código -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Código <span class="text-error-500">*</span>
            <span class="ml-1 text-xs text-gray-400 font-normal"
              >(se guardará en mayúsculas)</span
            >
          </label>
          <input
            type="text"
            name="code"
            [(ngModel)]="code"
            appPreventLongNames
            appPreventSpecialCharacters
            (invalidCharacter)="setError($event)"
            (invalidNameLength)="setError($event)"
            (input)="error = ''"
            required
            placeholder="Ej: REFERIDO, WEB, COLD_CALL"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Descripción -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Descripción
          </label>
          <textarea
            name="description"
            [(ngModel)]="description"
            appPreventSpecialCharacters
            appPreventLongDescriptions
            [descriptionMaxLength]="500"
            (invalidDescriptionLength)="setError($event)"
            (invalidCharacter)="setError($event)"
            (input)="error = ''"
            rows="3"
            placeholder="Descripción del origen (opcional)"
            class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          ></textarea>
        </div>

        <!-- Botones -->
        <div
          class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700"
        >
          <app-button
            variant="outline"
            type="button"
            (btnClick)="cancelar()"
          >
            Cancelar
          </app-button>
          <app-button
            variant="primary"
            type="submit"
            [disabled]="saving"
          >
            {{
              saving
                ? 'Guardando...'
                : isEditing
                  ? 'Actualizar'
                  : 'Crear Origen'
            }}
          </app-button>
        </div>
      </form>
    }
  </app-component-card>
</div>
